<template lang="html">
  <div class="editor image" style="position: absolute;top: 0;left: 0;bottom: 0;right: 0;overflow: auto;" @copy="onCopy($event)" @paste="onPaste($event)">
    <div class="container" @wheel.ctrl.prevent="setZoom(zoomSize + ($event.deltaY * -0.02))">
      <div style="display: table;width: 100%;height: 100%;">
        <div style="display: table-cell;vertical-align: middle;text-align: center;">
          <div class="image-container bg_transparent" style="display: inline-block;position: relative;" :style="{cursor: cursorStyle}"></div>
        </div>
      </div>
    </div>
    <div class="controls float-panel">
      <div class="controls-group" style="padding: 8px 12px;">
        <button v-for="tool in tools" :key="tool.type" type="button" class="btn-icon" :class="{selected: tool.type === selectedTool}" @click="selectTool(tool.type)" :title="tool.label"><i :class="tool.icon"></i></button>
        <button type="button" class="btn-icon" @click="randomDraw('p1')" title="Randomize P1"><i class="icon-dice"></i></button>
        <button type="button" class="btn-icon" @click="randomDraw('p2')" title="Randomize P2"><i class="icon-dice"></i></button>
      </div>
      <div class="controls-group tool-properties" style="padding: 8px 12px;">
        <select v-model="brushSize" @change="brushSize = parseInt(brushSize)" v-if="[Tool.PAINT, Tool.ERASER].indexOf(selectedTool) !== -1">
          <option v-for="size in [1,3,5,7,9,11]" :key="size" :value="size">x{{size}}</option>
        </select>
        <div v-if="Tool.SELECTION === selectedTool">
          <button type="button" class="btn-icon" @click="copyImage()" title="Copy"><i class="icon-content_copy"></i></button>
          <button type="button" class="btn-icon" @click="pasteImageBtn()" title="Paste"><i class="icon-content_paste"></i></button>
          <button type="button" class="btn-icon" @click="clearCanvasSelection()" title="Clear" v-if="canvasSelection"><i class="icon-close"></i></button>
          <div style="display: flex;flex-wrap: wrap;" v-if="canvasSelection && canvasSelection.rect">
            <div v-for="(label, variable) in {left: 'X', top: 'Y', width: 'W', height: 'H'}" :key="variable" style="width: 50%;padding-right: 8px;padding-top: 8px;">
              <div class="input-group">
      					<input type="text" v-model="canvasSelection.rect[variable]" @input="updateCanvas()">
      					<span class="input-group-append">{{label}}</span>
      				</div>
            </div>
    			</div>
        </div>
      </div>
      <div class="controls-group" style="text-align: center;">
        <button type="button" class="btn-icon" @click="setZoom(zoomSize - 3)" title="Zoom out"><i class="icon-zoom_out"></i></button>
        <input type="range" min="1" max="25" v-model="zoomSize" class="slider" @input="setZoom(zoomSize)" />
        <button type="button" class="btn-icon" @click="setZoom(zoomSize + 3)" title="Zoom in"><i class="icon-zoom_in"></i></button>
      </div>
      <div class="controls-group" style="padding: 8px 12px;display: flex;">
        <div class="input-group" style="margin-left: 0;">
          <input type="text" v-model="meta.width" @change="resizeCanvas()">
          <span class="input-group-append">W</span>
        </div>
        <div class="input-group" style="margin-left: 10px;">
          <input type="text" v-model="meta.height" @change="resizeCanvas()">
          <span class="input-group-append">H</span>
        </div>
        <select style="margin-left: 10px;" v-model="resizeType">
          <option>image</option>
          <option>canvas</option>
        </select>
      </div>
      <div class="controls-group">
        <label class="title">Color Picker</label>
        <ColorPicker v-if="brushColor" :value="brushColor" style="width: auto;" @input="changeBrushColor($event.rgba)" />
        <ColorPalette :value="brushColor" @change="changeBrushColor($event)" />
      </div>
  	</div>
  </div>
</template>

<script>
// import GameStudio from '@/assets/js/GameStudio.js'
import ColorPicker from '@/assets/components/image/ColorPicker.vue'
import ColorPalette from '@/assets/components/image/ColorPalette.vue'
const Util = window.Util;
const UtilEditor = window.UtilEditor;
const UtilMath = window.UtilMath;
const Keyboard = window.Keyboard;
const CubePattern = window.CubePattern;
const ClipboardItem = window.ClipboardItem;
const Tool = {
  ERASER: 1,
  PAINT: 2,
  EYEDROPPER: 3,
  SELECTION: 4,
  FILL: 5
};

export default {
  props: ['fileData'],
  components: {
    ColorPicker,
    ColorPalette
  },
  data() {
    var offCanvas = document.createElement('canvas');
    return {
      Tool,
      tools: [
        {type: Tool.PAINT, label: 'Paint', icon: 'icon-brush', cursor: ["\ue145", '12 12']},
        {type: Tool.EYEDROPPER, label: 'Eyedropper', icon: 'icon-colorize', cursor: ["\ue3b8", '1 20']},
        {type: Tool.ERASER, label: 'Eraser', icon: 'icon-eraser', cursor: ["\ue145", '12 12']},
        {type: Tool.FILL, label: 'Fill', icon: 'icon-format_paint', cursor: ["\ue145", '12 12']},
        {type: Tool.SELECTION, label: 'Selection', icon: 'icon-tab_unselected', cursor: ["\ue145", '12 12']}
      ],
      selectedTool: null,
      zoomSize: 1,
      brushSize: 1,
      resizeType: 'canvas',
      meta: {
        width: offCanvas.width,
        height: offCanvas.height
      },
      canvasSelection: null,
      /* other */
      brushColor: {r: 0, g: 0, b: 0, a: 1},
      offCanvas: offCanvas,
      offCtx: null,
      canvas: null,
      ctx: null,
      paintPixBinded: null,
      lastPix: null,
      isPainting: false
    };
  },
  computed: {
    cursorStyle() {
      try {
        const tool = this.tools.find(t => t.type === this.selectedTool);
        if (tool && tool.cursor) {
          const text = tool.cursor[0];
        	const hotspot = tool.cursor[1];
          return 'url(' + UtilEditor.getCursorImage(text) + ') ' + hotspot + ', auto';
        }
      } catch (e) {
        console.log(e);
      }
      return '';
    }
  },
  methods: {
    changeFileData(value) {
    	this.fileData.data = value;
    },
    selectTool(tool) {
      this.selectedTool = tool;
    },
    setZoom(size) {
      this.zoomSize = parseFloat(UtilMath.clamp(size, 1, 25));
      this.createStageCanvas();
    },
    randomDraw(pattern) {
      var cubePattern = new CubePattern(pattern, this.offCanvas.width, this.offCanvas.height);
      this.offCtx.clearRect(0, 0, this.offCanvas.width, this.offCanvas.height);
      this.offCtx.putImageData(cubePattern.getImageData(), 0, 0);
      this.updateCanvas();
    },
    updateMeta() {
      this.meta = {
        width: this.offCanvas.width,
        height: this.offCanvas.height
      };
    },
    resizeCanvas() {
      var clone = Util.cloneCanvas(this.offCanvas);
      this.offCanvas.width = this.meta.width;
    	this.offCanvas.height = this.meta.height;
      Util.canvasDisableImageSmoothing(this.offCanvas);
      this.offCtx = this.offCanvas.getContext('2d');
      switch (this.resizeType) {
        case 'image':
          this.offCtx.drawImage(clone, 0, 0, clone.width, clone.height, 0, 0, this.offCanvas.width, this.offCanvas.height);
          break;
        case 'canvas':
          this.offCtx.drawImage(clone, 0, 0, clone.width, clone.height, 0, 0, clone.width, clone.height);
          break;
      }
      this.canvasSelection = null;
      this.createStageCanvas();
    },
    copyImage() {
      if (!this.canvasSelection || !this.canvasSelection.rect) return;
      var x = this.canvasSelection.rect.left;
      var y = this.canvasSelection.rect.top;
      var width = this.canvasSelection.rect.width;
      var height = this.canvasSelection.rect.height;
      var canvas = Util.sliceImageAsCanvas(this.offCanvas, x, y, width, height);
      try {
        navigator.clipboard.write([new ClipboardItem({'image/png': Util.toBlob(canvas.toDataURL('image/png'))})]);
      } catch (e) {
        console.log(e);
      }
    },
    pasteImageBtn() {
      var self = this;
      try {
        navigator.clipboard.read().then(function (items) {
          var item = items.find(i => i.types.find(t => t.startsWith('image')));
          if (!item) return;
          var type = item.types.find(t => t.startsWith('image'));
          item.getType(type).then(function (blob) {
            self.pasteImage(blob);
          });
        });
      } catch (e) {
        console.log(e);
      }
    },
    clearCanvasSelection() {
      this.canvasSelection = null;
      this.updateCanvas();
    },
    updateCanvas() {
      const extension = this.fileData.name.split('.').pop();
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(this.offCanvas, 0, 0, this.offCanvas.width, this.offCanvas.height, 0, 0, this.canvas.width, this.canvas.height);
      if (this.canvasSelection && this.canvasSelection.rect) {
        this.ctx.setLineDash([6]);
        this.ctx.lineDashOffset = 0;
        this.ctx.strokeStyle = '#000';
        this.ctx.strokeRect(this.canvasSelection.rect.left * this.zoomSize, this.canvasSelection.rect.top * this.zoomSize, this.canvasSelection.rect.width * this.zoomSize, this.canvasSelection.rect.height * this.zoomSize);
        this.ctx.lineDashOffset = 6;
        this.ctx.strokeStyle = '#fff';
        this.ctx.strokeRect(this.canvasSelection.rect.left * this.zoomSize, this.canvasSelection.rect.top * this.zoomSize, this.canvasSelection.rect.width * this.zoomSize, this.canvasSelection.rect.height * this.zoomSize);
      }
      this.changeFileData(this.offCanvas.toDataURL(extension === 'png' ? "image/png" : "image/jpeg"));
    },
    onCopy(event) {
      if (!this.canvasSelection || !this.canvasSelection.rect) return;
      event.preventDefault();
      this.copyImage();
    },
    onPaste(event) {
      var item = Util.find(event.clipboardData.items, (f) => f.type.startsWith('image'));
      if (!item) return;
      this.pasteImage(item.getAsFile());
    },
    changeBrushColor(rgba) {
      this.brushColor = rgba;
    },
    pasteImage(file) {
      if (!this.canvasSelection || !this.canvasSelection.rect) return;
      var x = this.canvasSelection.rect.left;
      var y = this.canvasSelection.rect.top;
      var width = this.canvasSelection.rect.width;
      var height = this.canvasSelection.rect.height;
      Util.readFile(file).then((dataurl) => {
        Util.loadImageSrc(dataurl, (image) => {
          this.offCtx.drawImage(image, 0, 0, image.width, image.height, x, y, width, height);
          this.updateCanvas();
        });
      });
    },
    getMagicWandPath(x, y) {
      const imageData = this.offCtx.getImageData(0, 0, this.offCanvas.width, this.offCanvas.height).data;
      const matchColor = Array.prototype.slice.call(this.offCtx.getImageData(x, y, 1, 1).data);
      const path = new Path2D();
      const scheduleStack = [];
      const points = [];
      const schedule = function (x, y) {
        const coord = [x, y].join(',');
        if (!points.includes(coord) && !scheduleStack.includes(coord)) {
          scheduleStack.push(coord);
        }
      };
      const width = this.offCanvas.width;
      const getColor = function (x, y) {
        const pxIndex = (x + width * y) * 4;
        return [
          imageData[pxIndex],
          imageData[pxIndex + 1],
          imageData[pxIndex + 2],
          imageData[pxIndex + 3]
        ];
      };
      schedule(x, y);
      while (scheduleStack.length) {
        const coord = scheduleStack.pop();
        if (points.includes(coord)) continue;
        const [ x, y ] = coord.split(',').map(n => parseInt(n));
        if (x < 0 || y < 0 || x >= this.offCanvas.width || y >= this.offCanvas.height) continue;
        if (matchColor.join(',') === getColor(x, y).join(',')) {
          points.push(coord);
          path.rect(x, y, 1, 1);
          schedule(x - 1, y);
          schedule(x + 1, y);
          schedule(x, y - 1);
          schedule(x, y + 1);
        }
      }
      return path;
    },
    paintPix(event) {
      if (['mouseup', 'touchend'].includes(event.type)) {
        if (this.isPainting && this.selectedTool === Tool.EYEDROPPER) {
          this.selectTool(Tool.PAINT);
        }
        this.isPainting = false;
        this.lastPix = null;
        this.offCtx.restore();
        return;
      }
      event.preventDefault();
      const paintAction = (Keyboard.isDown(['MouseLeft']) || ['touchstart', 'touchmove'].includes(event.type));
      if (!paintAction) return;
      if (!this.isPainting) {
        this.isPainting = true;
        const color = 'rgba(' + [this.brushColor.r, this.brushColor.g, this.brushColor.b, this.brushColor.a] + ')';
        this.offCtx.fillStyle = color;
        this.offCtx.strokeStyle = color;
        this.offCtx.save();
        const paintAllowedRect = this.canvasSelection && this.canvasSelection.rect ? this.canvasSelection.rect : Util.getRect(0, 0, this.meta.width, this.meta.height);
        const clipMask = new Path2D();
        clipMask.rect(paintAllowedRect.x, paintAllowedRect.y, paintAllowedRect.width, paintAllowedRect.height);
        this.offCtx.clip(clipMask);
      }
      const mousePos = Util.eventPosition(event);
      if (mousePos.x < 0) mousePos.x = 0;
      if (mousePos.y < 0) mousePos.y = 0;
      const hotspot = {
        x: Math.trunc(mousePos.x / this.zoomSize),
        y: Math.trunc(mousePos.y / this.zoomSize)
      };
      const paintCoord = {
        x: hotspot.x - Math.trunc(this.brushSize / 2),
        y: hotspot.y - Math.trunc(this.brushSize / 2)
      };
      switch (this.selectedTool) {
        case Tool.ERASER:
          this.offCtx.clearRect(paintCoord.x, paintCoord.y, this.brushSize, this.brushSize);
          break;
        case Tool.PAINT:
          this.offCtx.fillRect(paintCoord.x, paintCoord.y, this.brushSize, this.brushSize);
          // var startPoint = this.lastPix || hotspot;
          // var ctx = this.offCtx;
          // ctx.mozImageSmoothingEnabled = false;
      		// ctx.webkitImageSmoothingEnabled = false;
      		// ctx.msImageSmoothingEnabled = false;
      		// ctx.imageSmoothingEnabled = false;
          // ctx.lineWidth = this.brushSize;
          // ctx.beginPath();
          // ctx.moveTo(startPoint.x, startPoint.y);
          // ctx.lineTo(hotspot.x+1, hotspot.y+1);
          // ctx.stroke();
          break;
        case Tool.EYEDROPPER:
          var color = this.offCtx.getImageData(hotspot.x, hotspot.y, 1, 1).data;
          color = Array.prototype.slice.call(color);
          color[3] = color[3]/255;
          this.changeBrushColor({r: color[0], g: color[1], b: color[2], a: color[3]});
          break;
        case Tool.SELECTION:
          if (this.canvasSelection) {
            this.canvasSelection.end = {x: hotspot.x, y: hotspot.y};
            this.canvasSelection.rect = UtilEditor.createRectByBorders({
              left: Math.min(this.canvasSelection.start.x, this.canvasSelection.end.x),
              top: Math.min(this.canvasSelection.start.y, this.canvasSelection.end.y),
              right: Math.max(this.canvasSelection.start.x, this.canvasSelection.end.x) + 1,
              bottom: Math.max(this.canvasSelection.start.y, this.canvasSelection.end.y) + 1
            });
            if (['touchstart', 'mousedown'].indexOf(event.type) !== -1) {
              this.canvasSelection = null;
            }
          } else {
            this.canvasSelection = {
              start: {x: hotspot.x, y: hotspot.y},
              end: null,
              rect: null
            };
          }
          break;
        case Tool.FILL:
          this.offCtx.fill(this.getMagicWandPath(hotspot.x, hotspot.y));
          break;
      }
      this.lastPix = hotspot;
      this.updateCanvas();
    },
    createStageCanvas() {
      var container = this.$el.querySelector('.image-container');
      container.innerHTML = '';
      this.canvas = container.appendChild(Util.nodefy('<canvas>'));
      var grid = container.appendChild(Util.nodefy('<div class="grid">')).appendChild(UtilEditor.gridGetSvg(this.zoomSize));
    	var listenerNode = container.appendChild(Util.nodefy('<div style="position: absolute;top: 0;left: 0;bottom: 0;right: 0;">'));
    	listenerNode.onmousemove = this.paintPixBinded;
    	listenerNode.onmousedown = this.paintPixBinded;
    	listenerNode.ontouchstart = this.paintPixBinded;
    	listenerNode.ontouchmove = this.paintPixBinded;

      grid.style.width = this.offCanvas.width * this.zoomSize + 'px';
      grid.style.height = this.offCanvas.height * this.zoomSize + 'px';

      this.canvas.width = this.offCanvas.width * this.zoomSize;
      this.canvas.height = this.offCanvas.height * this.zoomSize;
      Util.canvasDisableImageSmoothing(this.canvas);

      this.ctx = this.canvas.getContext('2d');
      this.updateCanvas();
    }
  },
  mounted() {
    this.paintPixBinded = this.paintPix.bind(this);
    document.addEventListener('mouseup', this.paintPixBinded, true);
    document.addEventListener('touchend', this.paintPixBinded, true);
    this.selectTool(Tool.PAINT);
    this.changeBrushColor(this.brushColor);

    Util.loadImageSrc(this.fileData.data, (image) => {
      this.offCanvas.width = image.width;
    	this.offCanvas.height = image.height;
      this.updateMeta();
      Util.canvasDisableImageSmoothing(this.offCanvas);
      this.offCtx = this.offCanvas.getContext('2d');
    	this.offCtx.drawImage(image, 0, 0, image.width, image.height, 0, 0, this.offCanvas.width, this.offCanvas.height);
      this.createStageCanvas();
    });
  },
  beforeUnmount() {
    console.log('Destroy');
    document.removeEventListener('mouseup', this.paintPixBinded, true);
    document.removeEventListener('touchend', this.paintPixBinded, true);
  }
}
</script>

<style lang="css" scoped>
.editor.image .image-container img {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.editor.image .container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 250px;
  overflow: auto;
  transition: right 0.7s;
}
.tool-properties:empty:before {
	content: 'No properties for this tool';
	opacity: 0.3;
	font-size: 13px;
	padding: 6px;
	display: inline-block;
	font-style: italic;
}
</style>
